import axios from 'axios'

export default {
  actions: {
    async getVariables ({ commit }, query) {
      const variables = ['HELP_PHONE_LINK', 'HELP_PHONE_TEXT']
      for (const x of variables) {
        const { data } = await axios.get(`/api/variables/${x}`)
        commit('setVariable', {
          name: x,
          value: data.value
        })
      }
    }
  },
  mutations: {
    setVariable (state, variable) {
      state.variables[variable.name] = variable.value
    }
  },
  state: {
    variables: {}
  },
  getters: {
    variables: state => state.variables
  }
}
